import _ from 'lodash';
import { GRADEBOOK_SETTINGS } from '../utils/constants.js';
import { toolIsManuallyGraded } from '../utils/tool.js';
import { round, shouldTallyAssignment, GRADEBOOK_GRADING_TYPES } from '../GradebookCalculations/GradebookCalculations.js';

const simpleRound = (num, preventDeleteZeros) => {
  let grade = round(parseFloat(num), 2);
  if (grade.slice(-3) === '.00' && !preventDeleteZeros) {
    grade = round(parseFloat(num), 0);
  }

  return grade;
};

function showDashForMissed (tool, gradingType, subtype) {
  return (
    toolIsManuallyGraded(tool, subtype) ||
    gradingType === GRADEBOOK_GRADING_TYPES.EXTRA_CREDIT
  );
}

const isAssignmentReportable = (assignment, settings) => {
  const { id, past_due: pastDue, isAggregateCell } = assignment || {};
  return (
    shouldTallyAssignment(assignment, settings) ||
    pastDue ||
    isAggregateCell ||
    _.isEmpty(id)
  );
};

const formatDisplayGrade = (
  grade,
  assignment = {},
  settings = [],
  options = {},
  roundPercentType = GRADEBOOK_SETTINGS.roundPercentWhole
) => {
  const opts = _.assign(
    {},
    { forceShowGrade: false, precision: precisionFrom(roundPercentType) },
    options
  );
  const { tool, subtype, status, isDropped, isAssigned = true, grading_type } = assignment || {};

  if (opts.forceShowGrade) {
    const formattedGrade = round(parseFloat(grade * 100), opts.precision);
    return `${formattedGrade}%`;
  }
  if (!isAssigned) return '-';
  if (isDropped) {
    const formattedGrade = round(parseFloat(grade * 100), opts.precision);
    return `${formattedGrade}%`;
  }
  if (status === 'Missed') {
    return showDashForMissed(tool, grading_type, subtype)
      ? '--'
      : `${round(parseFloat(0), opts.precision)}%`;
  }
  if (
    status !== 'Missed' &&
    _.isNumber(grade) &&
    !isNaN(grade) &&
    isAssignmentReportable(assignment, settings)
  ) {
    const formattedGrade = round(parseFloat(grade * 100), opts.precision);
    return `${formattedGrade}%`;
  }

  return '--';
};

const formatDisplayPoints = (assignment, settings, options = {}) => {
  const opts = _.assign({}, { forceShowGrade: false, precision: 2, ignoreDecimalZeros: false }, options);
  const {
    tool,
    subtype,
    status,
    isDropped,
    studentPoints,
    isAssigned = true,
    grading_type
  } = assignment || { studentPoints: 0 };

  if (opts.forceShowGrade) {
    return round(parseFloat(studentPoints), opts.precision, opts.ignoreDecimalZeros);
  }
  if (!isAssigned) return '-';
  if (isDropped) {
    return round(parseFloat(studentPoints), opts.precision, opts.ignoreDecimalZeros);
  }

  if (status === 'Missed') { return showDashForMissed(tool, grading_type, subtype) ? '--' : 0; }
  if (
    status !== 'Missed' &&
    _.isNumber(studentPoints) &&
    isAssignmentReportable(assignment, settings)
  ) {
    return round(parseFloat(studentPoints), opts.precision, opts.ignoreDecimalZeros);
  }
  return '--';
};

const precisionFrom = (roundPercentType = 5) => {
  let precisionlvl = 0;
  if (roundPercentType === GRADEBOOK_SETTINGS.roundPercentWhole) {
    precisionlvl = 0;
  } else if (roundPercentType === GRADEBOOK_SETTINGS.roundPercentTenths) {
    precisionlvl = 1;
  } else if (roundPercentType === GRADEBOOK_SETTINGS.roundPercentHundredths) {
    precisionlvl = 2;
  }
  return precisionlvl;
};

export {
  precisionFrom,
  formatDisplayGrade,
  formatDisplayPoints,
  simpleRound,
  showDashForMissed
}
